import ToolKit from './toolkit.vue'

export default ToolKit
export { default as ToolKit } from './toolkit.vue'
